/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type HideSageSyncAnalysisIssuesInput = {
    ids?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type hideSageSyncAnalysisIssuesMutationVariables = {
    input: HideSageSyncAnalysisIssuesInput;
};
export type hideSageSyncAnalysisIssuesMutationResponse = {
    readonly hideSageSyncAnalysisIssues: {
        readonly ids: ReadonlyArray<string | null> | null;
    } | null;
};
export type hideSageSyncAnalysisIssuesMutation = {
    readonly response: hideSageSyncAnalysisIssuesMutationResponse;
    readonly variables: hideSageSyncAnalysisIssuesMutationVariables;
};



/*
mutation hideSageSyncAnalysisIssuesMutation(
  $input: HideSageSyncAnalysisIssuesInput!
) {
  hideSageSyncAnalysisIssues(input: $input) {
    ids
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "HideSageSyncAnalysisIssuesInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HideSageSyncAnalysisIssuesPayload",
    "kind": "LinkedField",
    "name": "hideSageSyncAnalysisIssues",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ids",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hideSageSyncAnalysisIssuesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hideSageSyncAnalysisIssuesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "hideSageSyncAnalysisIssuesMutation",
    "operationKind": "mutation",
    "text": "mutation hideSageSyncAnalysisIssuesMutation(\n  $input: HideSageSyncAnalysisIssuesInput!\n) {\n  hideSageSyncAnalysisIssues(input: $input) {\n    ids\n  }\n}\n"
  }
};
})();
(node as any).hash = '58d9258aa946517db6b28ac02a1c5d25';
export default node;
